module.exports = __webpack_public_path__ + "img/Integral.16c56663.svg";